import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Philosophy from './components/Philosophy';
import Obsession from './components/Obsession';
import WhatWeBuild from './components/WhatWeBuild';
import Process from './components/Process';
import ProjectsSection from './components/ProjectsSection';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import {
  trackPageView,
  initScrollDepth,
  initSectionTracking,
  initTimeOnPage,
} from './analytics';

function App() {
  useEffect(() => {
    trackPageView();
    const cleanScroll  = initScrollDepth();
    const cleanSection = initSectionTracking();
    const cleanTime    = initTimeOnPage();
    return () => {
      cleanScroll();
      cleanSection();
      cleanTime();
    };
  }, []);

  return (
    <div style={{ background: '#fff', color: '#000' }}>
      <Navbar />
      <Hero />
      <Philosophy />
      <Obsession />
      <WhatWeBuild />
      <Process />
      <ProjectsSection />
      <FinalCTA />
      <Footer />
    </div>
  );
}

export default App;
